import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";

const NonBankLoanContents = ({ active }) => {
  const { category, articles } = useStaticQuery(graphql`
    query NonBankLoanContents {
      category: mysqlTerms(cluster: {eq: "localfirms_2"}) {
        term_normalized
        path
      }

      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-pozabankowe"}}}},
        limit: 6
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  return (<>
    {category && (
      <Link 
        className={[b.btn, "btn-light", "btn-cta", 'button-white', b.mb4].join(" ")} 
        to={resolveUrl(category.path, category.term_normalized)}
      >
        {active && <Icon size={17} icon="Info" />}

        Informacje o pożyczkach pozabankowych
      </Link>
    )}

    {active && articles.nodes.length > 0 && (<>
      <strong>Artykuły o pożyczkach pozabankowych</strong>

      <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
        {articles.nodes.map((article, i) => (
          <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
            <img src={article.thumbnail_canvas?.replace('/fa/', '/fk/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
            
            <strong>{article.title}</strong>
          </Link>
        ))}
      </div>  
    </>)}
  </>);
};

export default NonBankLoanContents;
